import { inicializarInternacionalizacao } from '../localizacao/loadBotao/loadBotao'
import i18next from 'i18next';

export const loadBotao = {
    mostrar(elementoButton, mensagem = 'Aguarde...') {
        inicializarInternacionalizacao();
        if (mensagem == 'Aguarde...')
            mensagem = i18next.t('Aguarde')
        
        elementoButton.setAttribute('data-html-loader', elementoButton.innerHTML);
        elementoButton.setAttribute('disabled', 'disabled');
        elementoButton.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ' + mensagem;
    },
    esconder(elementoButton) {
        const textoBotao = elementoButton.getAttribute('data-html-loader');
        elementoButton.removeAttribute('disabled');
        elementoButton.innerHTML = textoBotao;
    }
};